import { useTranslation } from 'react-i18next';

/**
 * Header/footer language toggle — active code in gold (matches design: EN | VI).
 */
export default function LanguageSwitcher({ className = 'nav-lang' }) {
  const { i18n, t } = useTranslation('common');

  const lang = i18n.language?.startsWith('vi') ? 'vi' : 'en';

  const setLang = (code) => {
    if (code === lang) return;
    i18n.changeLanguage(code);
  };

  return (
    <div className={className} role="group" aria-label="Language">
      <button
        type="button"
        onClick={() => setLang('en')}
        aria-pressed={lang === 'en'}
        style={{
          background: 'none',
          border: 'none',
          padding: 0,
          font: 'inherit',
          color: lang === 'en' ? 'var(--gold)' : 'inherit',
          cursor: lang === 'en' ? 'default' : 'pointer',
          letterSpacing: 'inherit',
        }}
      >
        {t('lang.en')}
      </button>
      {' | '}
      <button
        type="button"
        onClick={() => setLang('vi')}
        aria-pressed={lang === 'vi'}
        style={{
          background: 'none',
          border: 'none',
          padding: 0,
          font: 'inherit',
          color: lang === 'vi' ? 'var(--gold)' : 'inherit',
          cursor: lang === 'vi' ? 'default' : 'pointer',
          letterSpacing: 'inherit',
        }}
      >
        {t('lang.vi')}
      </button>
    </div>
  );
}
